<style lang="scss">
    .share-button {
        padding: 5px;
    }
</style>

<template>
    <a class="share-button" href="javascript:;" @click.stop="share()">Share <font-awesome-icon icon="share-alt"></font-awesome-icon></a>
</template>

<script>
    export default {
        mounted() {
            this.shareCartModal = $("#shareCartModal")
        },
        data() {
            return {
                shareCartModal: null
            }
        },
        methods: {
            share() {
                if (this.shareCartModal) {
                    this.shareCartModal.modal('show')
                }
            },
        }
    }
</script>